import { Box, Stack } from '@mui/material';
import { ATSVacanciesModalTestIds } from 'data-testids/ATS';
import { useState } from 'react';
import { ToggleButtons } from 'sharedComponents/Buttons/ToggleButtons';
import { schoolVacancyOptions } from '../data';
import { StyledInputBase } from '../styles';
import { SchoolTable } from './School/SchoolTable';
import SearchIcon from '@mui/icons-material/Search';

export const SchoolVacancies = () => {
  const [currentSchoolVacancyView, setCurrentSchoolVacancyView] = useState(schoolVacancyOptions[0]);
  const [searchInput, setSearchInput] = useState('');

  const handleSetType = (newView) => setCurrentSchoolVacancyView(newView);

  return (
    <Box data-testid={ATSVacanciesModalTestIds.SCHOOL_VACANCY_PANE}>
      <Stack direction="row">
        <StyledInputBase
          value={searchInput}
          onChange={(event) => setSearchInput(event.target.value)}
          placeholder="Type a school name"
          startAdornment={<SearchIcon sx={{ ml: 2 }} />}
        />
        <Stack justifyContent="center" sx={{ ml: 3 }}>
          <ToggleButtons
            dataTestId={ATSVacanciesModalTestIds.SCHOOL_VACANCY_TYPE_TOGGLE}
            options={schoolVacancyOptions}
            currentlySelected={currentSchoolVacancyView?.title === 'School' ? 0 : 1}
            onToggle={handleSetType}
          />
        </Stack>
      </Stack>
      {currentSchoolVacancyView.title === 'School' && (
        <SchoolTable searchInput={searchInput} variant="single" />
      )}
      {currentSchoolVacancyView.title === 'Group' && (
        <SchoolTable searchInput={searchInput} variant="group" />
      )}
    </Box>
  );
};
